<template>
  <Head title="Avid + Wiland Benchmarks" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
         <benchmark-view-wiland
            :user="auth.user" 
            :client="client" 
            :connections="connections" 
            :section_id="normalizedSectionId"
            :dashboard_pages="dashboard_pages"
            :report_groups="report_groups"
         />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import { computed } from 'vue';
import AppLayout from '../../Layouts/AppLayout.vue';

const props = defineProps({
  client: Object,
  connections: Array,
  section_id: [Number, String],
  auth: Object,
  dashboard_pages: {
    type: Array,
    default: () => []
  },
  report_groups: {
    type: Array,
    default: () => []
  }
});

const normalizedSectionId = computed(() => {
  const id = props.section_id;
  if (id == null || id === '' || id === 'dashboard') return null;
  if (id === 'full') return 'full';
  const n = Number(id);
  return Number.isInteger(n) ? n : null;
});
</script>

